import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { IconButtonComponent, TextareaComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tellent-assistant-input',
  standalone: true,
  imports: [ReactiveFormsModule, TextareaComponent, IconButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <form (submit)="$event.preventDefault(); submit()">
      <rt-textarea
        class="input"
        [formControl]="control"
        placeholder="Ask me anything…"
        [autoHeight]="true"
        [maxHeight]="96"
        (keydown.enter)="onEnter($event)"
      />

      <div class="actions">
        @if (busy()) {
          <rt-icon-button iconName="stop" size="small" variant="primary" (click)="stop.emit()" />
        } @else {
          <rt-icon-button
            iconName="arrow-upward"
            size="small"
            variant="primary"
            [disabled]="!canSend()"
            (click)="submit()"
          />
        }
      </div>
    </form>
  `,
  styleUrls: ['./tellent-assistant-input.component.less'],
})
export class TellentAssistantInputComponent {
  protected readonly control = new FormControl<string>('', { nonNullable: true });
  protected readonly draft = signal<string>('');

  public readonly busy = input<boolean>(false);
  public readonly waitingOnInterrupt = input<boolean>(false);
  public readonly send = output<string>();
  public readonly stop = output<void>();

  constructor() {
    this.control.valueChanges.subscribe(v => this.draft.set(v ?? ''));
  }

  protected canSend(): boolean {
    return this.draft().trim().length > 0 && !this.waitingOnInterrupt();
  }

  protected submit(): void {
    if (!this.canSend()) return;
    this.send.emit(this.draft().trim());
    this.control.reset('');
  }

  protected onEnter(event: Event): void {
    const ev = event as KeyboardEvent;
    if (ev.shiftKey) return;
    ev.preventDefault();
    this.submit();
  }
}
